import React from "react";
import LabelWithInputDisabled from "../../../components/generic/LabelWithInputDisabled";
import MatchTypeComponent from "./MatchTypeComponent";

function FileMoveView(props) {
  return (
    <div>
      <LabelWithInputDisabled label="Action Type" value={props.eventType} />
      <MatchTypeComponent
        matchType={props.matchType}
        fileName={props.fileName}
      />
    </div>
  );
}

export default FileMoveView;
